import * as React from 'react'

import { Box, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type Holidays from 'modules/shift_management/store/internal/collections/Holidays'
import type Leaves from 'modules/shift_management/store/internal/collections/Leaves'
import type RestDays from 'modules/shift_management/store/internal/collections/RestDays'

import LeaveItem from './LeaveItem'
import RestDayItem from './RestDayItem'

interface Props {
  date: moment.Moment
  leaves: Leaves
  holidays: Holidays
  restDays: RestDays
}

const DayItem = ({ date, leaves, holidays, restDays }: Props) => {
  const { leavesLength, leaveTypes } = leaves
  const { holidaysLength, holidaysInformation } = holidays
  const { restDaysLength } = restDays
  const hasLeaves = !!leavesLength
  const hasHolidays = !!holidaysLength
  const hasRestDays = !!restDaysLength

  return (
    <Box gap="s16">
      <Box flexDirection="row" alignItems="center" gap="s16">
        <Text.Normal weight="medium" color="grey1000">
          {date.format('dddd D')}
        </Text.Normal>
        {hasLeaves && <Tag type="champagne">{leavesLength}</Tag>}
        {hasRestDays && <Tag type="fuchsia">{restDaysLength}</Tag>}
      </Box>
      {!hasLeaves && (
        <Text.Normal weight="medium">
          {i18n.t('shift_management.sidepanel.no_absences')}
        </Text.Normal>
      )}
      {hasLeaves &&
        leaveTypes.map((leaveType) => (
          <Box gap="s16" key={leaveType}>
            <Text.Normal weight="bold" size="200">
              {leaveType}
            </Text.Normal>
            {leaves.filterByType(leaveType).map((leave) => (
              <LeaveItem key={leave.id} date={date} leave={leave} />
            ))}
          </Box>
        ))}
      {hasHolidays && (
        <Box gap="s16">
          <Text.Normal weight="bold" size="200">
            {i18n.t('shift_management.sidepanel.bank_holidays')}
          </Text.Normal>
          {holidaysInformation.map((info) => (
            <Box key={info}>
              <Text.Normal weight="medium">{info}</Text.Normal>
            </Box>
          ))}
        </Box>
      )}
      {hasRestDays && (
        <Box gap="s16">
          <Text.Normal weight="bold" size="200">
            {i18n.t('shift_management.sidepanel.rest_days')}
          </Text.Normal>
          {restDays.filterByDate(date).map((restDay) => (
            <RestDayItem key={restDay.id} date={date} restDay={restDay}></RestDayItem>
          ))}
        </Box>
      )}
    </Box>
  )
}

export default observer(DayItem)
